import { useCanvasNoteStyle } from "../../../../hooks/useCanvasNoteStyle";
import { NOTE_COLORS } from "../../../../nodes/shared/CanvasColorPalettes";
import {
  SwatchGrid,
  Tray,
  TrayDeck,
  TrayNewRow,
  TraySection,
  type TrayNewRowProps,
} from "../CanvasTrayContent";

/**
 * The one thing a note has before it exists that the product lets you
 * choose: its colour. Nine tints, the rail the bar's tile wears
 * (DECISIONS D4). Size, layout and body style are not pre-placement
 * settings here, so the spec's rows for them are not drawn. Popped, New
 * note under the tints arms placement the way the tile does.
 */
export function StickyTray({
  newNote,
}: {
  /** The New note row; absent, the row is not drawn. */
  newNote?: TrayNewRowProps;
}) {
  const { noteColor, setNoteColor } = useCanvasNoteStyle();
  const items = NOTE_COLORS.map((c) => ({
    key: c.value,
    name: c.name,
    tint: c.swatchHex,
  }));
  return (
    <Tray>
      <TrayDeck>
        <TraySection ariaLabel="Note color">
          <SwatchGrid
            items={items}
            value={noteColor}
            onChange={setNoteColor}
            columns={items.length}
          />
        </TraySection>
        {newNote ? <TrayNewRow label="New note" {...newNote} /> : null}
      </TrayDeck>
    </Tray>
  );
}
